/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_CreatedInputs */

const en_statement_tree_created = /** @type {(inputs: Statement_Tree_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statement tree created`)
};

const nl_statement_tree_created = /** @type {(inputs: Statement_Tree_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stamboom aangemaakt`)
};

/**
* | output |
* | --- |
* | "Statement tree created" |
*
* @param {Statement_Tree_CreatedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_created = /** @type {((inputs?: Statement_Tree_CreatedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_CreatedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_created(inputs)
	return en_statement_tree_created(inputs)
});